import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'activityListFilter',
    standalone: false
})
export class ActivityListFilterPipe implements PipeTransform {

  transform(activity: any, params: any): any {
    /** Bug Fix #46606 */
        /** Bug Fix #46606 */
      /** 🐞 Bug Fix | Issue: 46606 | Root: Without filtering the activities of open booking  | Fix: Filtered the open booking activities by Open booking lesson type | By: Tharun | Date: 10/11/2025 */
    console.log('=== ActivityListFilter Debug ===');
    console.log('Params lessonType:', params.lessonType);
    console.log('All activities:', activity);
    console.log('Activity LessonTypes:', activity.map(a => ({ name: a.Name || a.LessonName, LessonType: a.LessonType, isArray: Array.isArray(a.LessonType) })));
    const activitiess = activity.filter(data => data.LessonType == params.lessonType);
    console.log('Filtered activities (after LessonType filter):', activitiess);
    console.log('=== End Debug ===');
    let activities = params.lessonType != null 
      ? activity.filter(data => [].concat(params.lessonType).includes(data.LessonType))
      : activity;
    const diff = moment(params.endDate ? params.endDate : params.startDate).diff(params.startDate, "days");
    const firstDay = moment(params.startDate);
    let weekdaysBetween = [];
    if (diff >= 6) {
      weekdaysBetween = [0, 1, 2, 3, 4, 5, 6];
    } else {
      for (let i = 0; i <= diff; i++) {
        weekdaysBetween.push(moment(firstDay).add(i, "days").day());
      }
    }
    var dateFilteredActivity = activities;
    if (!activities) {
      return [];
    } else if (!params.startDate && !params.endDate) {
      //return activities;
    } else if (params.startDate && !params.endDate) {
       dateFilteredActivity = activities.filter(eachActivity => {
        if (eachActivity.StartDate && eachActivity.EndDate) {
          return moment(eachActivity.StartDate?.split('T')[0]).isSameOrBefore(moment(params.startDate)) &&
            moment(eachActivity.EndDate?.split('T')[0]).isSameOrAfter(moment(params.startDate)) && eachActivity.ActivityDayOfWeeks?.some(item => weekdaysBetween.includes(item))
        } else {
          return eachActivity;
        }
      });
      //return filteredActivity;
    }
    dateFilteredActivity = activities.filter(eachActivity => {
      if (eachActivity.StartDate && eachActivity.EndDate) {
        return moment(eachActivity.StartDate?.split('T')[0]).isSameOrBefore(moment(params.endDate)) &&
          moment(eachActivity.EndDate?.split('T')[0]).isSameOrAfter(moment(params.startDate)) && eachActivity.ActivityDayOfWeeks?.some(item => weekdaysBetween.includes(item))
      } else {
        return eachActivity;
      }
    });
    //return filteredActivity;

    var nameFilteredActivity = dateFilteredActivity;
    if (params.searchText){
       nameFilteredActivity = dateFilteredActivity.filter(eachActivity => {
        if (eachActivity.Name)
          return eachActivity.Name.toLowerCase().includes(params.searchText.toLowerCase())
        else 
          return false;
      });
    }
    
    return nameFilteredActivity;

    activity.sort((a: any, b: any) => {
      if (a.LessonName.replace(/\s/g, "").toLowerCase() < b.LessonName.replace(/\s/g, "").toLowerCase()) {
        return -1;
      } else if (a.LessonName.replace(/\s/g, "").toLowerCase() > b.LessonName.replace(/\s/g, "").toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    });
    return activity;
  }

}
